import { render } from "./StaffTable.vue?vue&type=template&id=0fc24959&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"

import "./StaffTable.vue?vue&type=style&index=0&id=0fc24959&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc24959"]])

export default __exports__